import { render, staticRenderFns } from "./CardOutrosDadosPedidoInsumos.vue?vue&type=template&id=abb9a874&"
import script from "./CardOutrosDadosPedidoInsumos.vue?vue&type=script&lang=js&"
export * from "./CardOutrosDadosPedidoInsumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports